module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "CommandControl_Icon.35b84d6a.png";